import axios from 'axios'
const baseURL = process.env.VUE_APP_API_PREFIX;

const instance = axios.create({
    baseURL: baseURL,
    // baseURL: './api/',
    timeout: 15000
})

// 拦截器
// instance.interceptors.request.use(config => {
//     return config
// }, err => {

// })
// instance.interceptors.response.use(res => {
//     return response
// }, err => {

// })

export default instance
